import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { createContext, useContext, useMemo, useEffect } from 'react';
import invariant from 'invariant';
import { mergeComponents, mergeTokens } from '../utils';
import { map } from 'lodash';
export var StylesContext = createContext();
export function StylesProvider(_ref) {
  var modes = _ref.modes,
      components = _ref.components,
      tokens = _ref.tokens,
      extendsTheme = _ref.extends,
      props = _objectWithoutProperties(_ref, ["modes", "components", "tokens", "extends"]);

  var parentStyles = useContext(StylesContext);
  var value = useMemo(function () {
    var _parentStyles$compone, _parentStyles$tokens;

    return {
      modes: _objectSpread(_objectSpread({}, parentStyles === null || parentStyles === void 0 ? void 0 : parentStyles.modes), modes),
      components: mergeComponents(components, (_parentStyles$compone = parentStyles === null || parentStyles === void 0 ? void 0 : parentStyles.components) !== null && _parentStyles$compone !== void 0 ? _parentStyles$compone : {}),
      tokens: mergeTokens(tokens, (_parentStyles$tokens = parentStyles === null || parentStyles === void 0 ? void 0 : parentStyles.tokens) !== null && _parentStyles$tokens !== void 0 ? _parentStyles$tokens : {})
    };
  }, [modes, components, tokens, parentStyles]);
  useEffect(function () {
    var _context;

    var invalidKeys = _filterInstanceProperty(_context = map(components, function (_, key) {
      return _includesInstanceProperty(key).call(key, ' ') && key;
    })).call(_context, Boolean);

    invariant(invalidKeys.length <= 0, "Path context API is deprecated. Targeting elements with \"".concat(invalidKeys.join(', '), "\" will no longer override styles of nested components. Either refactor your components to not use path context or downgrade the installed version of \"@rexlabs/styling\" to \"2.x.x\""));
  }, [components]);
  return /*#__PURE__*/React.createElement(StylesContext.Provider, _extends({}, props, {
    value: value
  }));
}